import React,{useState} from 'react'
import Select from 'react-select';
import TextField from '@material-ui/core/TextField';



const ModelInput = (props)=>{
    return(
        <div className="d-flex" style={{
            width: '80%',
            marginLeft: 'auto',
            alignItems: 'center',
            padding: '20px 0px',
        }}>
            <div style={{
                width: '30%'
            }}>
                <span className="text-field-names-title">{props.title}</span>
            </div>
            {!props.isSelect ?
                <div className="model-input-field" style={{
                    border: 'none'
                }}>
                    <TextField 
                        id="outlined-basic" 
                        label="" 
                        variant="outlined"
                        style={{width: '100%'}}
                        size="small"
                        onChange={props.handleChange}
                        value={props.value}
                        type={props.type}
                        error={props.error}
                        helperText={props.helperText}
                     />
                </div>
            :
                <div className="model-input-field" style={{
                    border: 'none'
                }}>
                    
                    <Select
                        value={props.value}
                        onChange={props.handleChange}
                        options={props.options}
                        className="vertical-select-field"
                    />
                </div>
            }

        </div>

    )
}

export default ModelInput